class ServiceFormModel {
  constructor(displayOrder, submissionOrder, title, description, serviceName, action, fields, prefilled) {
    this.displayOrder = displayOrder;
    this.submissionOrder = submissionOrder;
    this.title = title;
    this.description = description;
    this.serviceName = serviceName;
    this.action = action;
    this.fields = fields;
    this.prefilled = prefilled;
  }
}

export { ServiceFormModel };
